import DuplicateIcon from "@redotech/redo-icons/copy-01.svg";
import { AbTestStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface AbTestNodeData {
  step: PartialWithRequiredType<AbTestStep>;
  deleteElements: (id: string) => void;
}

export function AbTestNode(data: {
  id: string;
  data: AbTestNodeData;
  selected?: boolean | undefined;
}) {
  const { step, deleteElements } = data.data;

  return (
    <BaseNode
      icon={<RedoFeaturedIcon color="warning" Icon={DuplicateIcon} size="xs" />}
      onDelete={() => deleteElements(data.id)}
      selected={data.selected}
      step={step}
      title={step.name || "Weighted branch"}
    >
      <Handle position={Position.Top} type="target" />
      <Flex
        className={NodeCSS.fullWidth}
        dir="column"
        gap="md"
        justify="flex-start"
      >
        <Text fontSize="xxs">Variations</Text>
        {step.variants && step.variants.length > 0 ? (
          <Text className={NodeCSS.valueText}>{step.variants.length}</Text>
        ) : (
          <Text className={NodeCSS.placeholderText}>Needs configuration</Text>
        )}
      </Flex>
      {/* Create a source handle for each variant */}
      {step.variants && step.variants.length > 0 ? (
        step.variants.map((variant, index) => (
          <Handle
            id={variant.id}
            key={variant.id}
            position={Position.Bottom}
            type="source"
          />
        ))
      ) : (
        <Handle position={Position.Bottom} type="source" />
      )}
    </BaseNode>
  );
}
